import styled, { css } from "styled-components";
import errorBorder from "../../styles/errorBorder";
import { Async as AsyncSelect } from "react-select";

export default styled(AsyncSelect)`
    ${props =>
        props.errorBorder &&
        css`
            .Select-control {
                ${errorBorder}
            }
        `}
`;
